import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { createEquipo } from '../../../controller/dispositivosController';
import { fetchSucursales } from '../../../controller/sucursalController'; // Asegúrate que sea la ruta correcta
import Dispositivo from '../../../models/dispostivo';
import { fetchUsuariosServicio } from '../../../controller/userController';

function DispositivosCreateView() {
  const navigate = useNavigate();
  const [equipo, setEquipo] = useState(new Dispositivo({}));
  const [sucursales, setSucursales] = useState([]);
  const [usuariosServicio, setUsuariosServicio] = useState([]);


  useEffect(() => {
  const cargarDatos = async () => {
    try {
      const [sucursalData, usuariosData] = await Promise.all([
        fetchSucursales(),
        fetchUsuariosServicio(),
      ]);

      setSucursales(sucursalData);
      setUsuariosServicio(usuariosData);

      setEquipo((prev) => ({
        ...prev,
        sucursal: sucursalData.length > 0 ? sucursalData[0].id : '',
        servicio: usuariosData.length > 0 ? usuariosData[0].id : '',
      }));
    } catch (error) {
      console.error('Error al cargar datos iniciales:', error);
    }
  };

  cargarDatos();
}, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setEquipo({
      ...equipo,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log(equipo)
      await createEquipo(equipo);
      navigate(-1);
    } catch (error) {
      console.error('Error al crear el dispositivo:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Crear Dispositivo</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={equipo.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Modelo</Form.Label>
          <Form.Control
            type="text"
            name="model"
            value={equipo.model}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Dirección IP</Form.Label>
          <Form.Control
            type="text"
            name="ip_address"
            value={equipo.ip_address}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Puerto</Form.Label>
          <Form.Control
            type="number"
            name="port"
            value={equipo.port}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            name="password"
            value={equipo.password}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Descripción</Form.Label>
          <Form.Control
            type="text"
            name="description"
            value={equipo.description}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Sucursal</Form.Label>
          <Form.Select
            name="sucursal"
            value={equipo.sucursal}
            onChange={handleChange}
            required
          >
            {sucursales.map((sucursal) => (
              <option key={sucursal.id} value={sucursal.id}>
                {sucursal.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

    <Form.Group className="mb-3">
  <Form.Label>Servicio</Form.Label>
  <Form.Select
    name="servicio"
    value={equipo.servicio}
    onChange={handleChange}
    required
  >
    {usuariosServicio.map((usuario) => (
      <option key={usuario.id} value={usuario.id}>
        {usuario.username}
      </option>
    ))}
  </Form.Select>
</Form.Group>


        <Button variant="primary" type="submit" className="me-2">
          Crear Dispositivo
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      </Form>
    </Container>
  );
}

export default DispositivosCreateView;
